import App from '@/models/App'

export default class ShipLaborAttendanceHoliday extends App {
    static get entity() {
        return 'ShipLaborAttendanceHolidays'
    }
    static all() {
        return this.query().get()
    }
    static findByDateAndSailor(date, sailorId) {
        return this.query()
            .where('attendanceAt', date)
            .where('shipSailorId', sailorId)
            .first()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipSailorId: this.attr(''),
            attendanceAt: this.attr(''),
            holiday: this.attr(''),
            type: this.attr(''),
            count: this.attr(0),
        }
    }
    static apiConfig = {
        actions: {
            fetch(sailorId, openedAt, closedAt, save = true) {
                return this.get(`${sailorId}/labor/attendances/holidays`, {
                    params: {
                        openedAt,
                        closedAt,
                    },
                    save,
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
            update(sailorId, holidays, openedAt, closedAt) {
                App.renewalSnackbar(); return Promise.resolve();
                const params = { data: JSON.stringify(holidays) }
                return this.patch(
                    `${sailorId}/labor/attendances/holidays`,
                    App.patch(params),
                    {
                        params: {
                            openedAt,
                            closedAt,
                        },
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
        },
    }
}
